import { styled } from '@mui/material'

const Img = styled('img')(({ theme }) => ({
    display: 'inline-block',
    maxWidth: '100%'
}))

const Image = (props: any) => {
    return (
        <Img {...props} />
    )
}

export default Image